import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { EncryptionMethod } from 'app/registries/consts/postgre-consts';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format, getConnectorLegacyNameByFlag } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.postgreSql.linkedServiceType,
    disabled: __IS_FABRIC_DPE__,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate,
            getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true)),
        format(stringResources.ModelName_LinkedServicesTemplate,
            getConnectorLegacyNameByFlag(stringResources.PostgreSql_DisplayText, true))
    ]
})
export class PostgreSqlLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly SERVER_NAME: IAttribute;
    public static readonly DATABASE_NAME: IAttribute;
    public static readonly PORT: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSWORD: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName,
        association: 'SERVER_NAME',
        templatable: true
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName,
        association: 'DATABASE_NAME',
        templatable: true
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port,
        association: 'PORT',
        accepts: ['String', 'Int'],
        templatable: true
    })
    public port?: number = 5432;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSWORD',
        templatable: true
    })
    public password?: string | AzureKeyVault;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public encryptionMethod: EncryptionMethod = EncryptionMethod.NoEncryption;
    public validateServerCertificate: boolean = true;

    public override isLegacyConnector = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
